<template>
  <div :class="`m-mobile m-mobile-${routeType}-main mobile-toreader`">
    <!-- <mobile-navbar :title="'致读者'"></mobile-navbar> -->
    <div class="carousel">
      <div class="block">
       <bs-page
            :filter="{pageIndex:1, pageSize: 7}"
            :meta="{ module:'news', field:'xwzx' }"
            :is-init="true">
            <template slot="data" slot-scope="slot">
              <el-carousel height="190px" indicator-position="none">
              <el-carousel-item v-for="(item,index) in slot.data" :key="item.newId" >
                <img src="../../assets/mobile/1.png" v-if="index===0" @click="handleNewDetail('news', item.typeId, item)">
                <img src="../../assets/mobile/2.png" v-if="index===1" @click="handleNewDetail('news', item.typeId, item)">
                <img src="../../assets/mobile/3.png" v-if="index===2" @click="handleNewDetail('news', item.typeId, item)"> 
                <img src="../../assets/mobile/4.png" v-if="index===3" @click="handleNewDetail('news', item.typeId, item)">
                <img src="../../assets/mobile/5.png" v-if="index===4" @click="handleNewDetail('news', item.typeId, item)">
                <img src="../../assets/mobile/jz.png" v-if="index===5" @click="handleNewDetail('news', item.typeId, item)">
                <img src="../../assets/mobile/wys.png" v-if="index===6" @click="handleNewDetail('news', item.typeId, item)">
                 <div class="item-title">{{item.title}}</div>
              </el-carousel-item>
            </el-carousel>
            </template>
            <template slot="empty">
            </template>
          </bs-page>
      </div>
    </div>
    <div class="badge">
      <ul>
        <li @click="handleCultiDetail('culture','zzwh')">
          <a href="javascript:;">
            <img src="../../assets/mobile/zhuziwenhua@2x.png">
            <p>文化内涵</p>
          </a>
        </li>
        <li @click="handleSingleArtiDetail('single-article','research')">
          <a href="javascript:;">
            <img src="../../assets/mobile/yanjiuhuixinxi@2x.png">
            <p>研究会信息</p>
          </a>
        </li>
        <li @click="handleSingleArtiDetail('single-article','contact')">
          <a href="javascript:;">
            <img src="../../assets/mobile/lianxiwomen@2x.png">
            <p>联系我们</p>
          </a>
        </li>
        <li @click="handleSociety('society-help','help')">
          <a href="javascript:;">
            <img src="../../assets/mobile/shehuizhuli@2x.png">
            <p>社会助力</p>
          </a>
        </li>
      </ul>
    </div>
    <div class="tablist">
      <el-tabs v-model="activeName" :stretch="true" @tab-click="handleClick">
        <el-tab-pane label="活动新闻" name="first">
          <bs-page
            :filter="{pageIndex:1, pageSize: 10}"
            :meta="{ module:'news', field:'xwzx' }"
            :is-init="true">
            <template slot="data" slot-scope="slot">
              <div class="list">
                <div
                  v-for="item in slot.data"
                  :key="item.newId"
                  @click="handleNewDetail('news','xwzx_detail',item)"
                >
                  <el-row>
                    <el-col :span="8">
                      <div class="grid-content">
                        <img :src="item.imgUrl||$app.mobilenodata.img">
                      </div>
                    </el-col>
                    <el-col :span="16">
                      <div class="list-txt">
                        <h5 v-text="item.title"></h5>
                        <p>
                          <span class="list-txt-left" v-text="item.pushDate||item.modifyDate"></span>
                          <span class="list-txt-mid" v-text="item.fromSource"></span>
                          <span class="list-txt-right">
                            <img src="../../assets/mobile/yidu@2x.png">
                            {{item.showNum}}已读
                          </span>
                        </p>
                      </div>
                    </el-col>
                  </el-row>
                </div>
              </div>
            </template>
            <template slot="empty">
              <div class="nodata">
                <img src="../../assets/mobile/zanwushuju.png">
              </div>
            </template>
            <template slot="paging">
              <div style="text-align:center">
                <p @click="handleNewsMore('news','xwzx')">更多</p>
              </div>
            </template>
          </bs-page>
        </el-tab-pane>
        <el-tab-pane label="通知公告" name="second">
          <bs-page
            :is-init="false"
            :filter="{pageIndex:1, pageSize: 10}"
            :meta="{ module:'news', field:'hdgg' }"
            ref="refId"
          >
            <template slot="data" slot-scope="slot">
              <div class="list">
                <div
                  v-for="item in slot.data"
                  :key="item.newId"
                  @click="handleNewDetail('news','hdgg_detail',item)"
                >
                  <el-row>
                    <el-col :span="8">
                      <div class="grid-content">
                        <img :src="item.imgUrl||$app.mobilenodata.img">
                      </div>
                    </el-col>
                    <el-col :span="16">
                      <div class="list-txt">
                        <h5 v-text="item.title"></h5>
                        <p>
                          <span class="list-txt-left" v-text="item.pushDate||item.modifyDate"></span>
                          <span class="list-txt-mid" v-text="item.fromSource"></span>
                          <span class="list-txt-right">
                            <img src="../../assets/mobile/yidu@2x.png">
                            {{item.showNum}}已读
                          </span>
                        </p>
                      </div>
                    </el-col>
                  </el-row>
                </div>
              </div>
            </template>
            <template slot="empty">
              <div class="nodata">
                <img src="../../assets/mobile/zanwushuju.png">
              </div>
            </template>
            <template slot="paging">
              <div style="text-align:center">
                <p @click="handleNewsMore('news','hdgg')">更多</p>
              </div>
            </template>
          </bs-page>
        </el-tab-pane>
        <el-tab-pane label="理学研究" name="fourth">
          <bs-page
            :is-init="false"
            :filter="{pageIndex:1, pageSize: 10}"
            :meta="{ module:'news', field:'llyj'}"
            ref="refId"
          >
            <template slot="data" slot-scope="slot">
              <div class="list">
                <div
                  v-for="item in slot.data"
                  :key="item.newId"
                  @click="handleNewDetail('news','llyj_detail',item)"
                >
                  <el-row>
                    <el-col :span="8">
                      <div class="grid-content">
                        <img :src="item.imgUrl||$app.mobilenodata.img">
                      </div>
                    </el-col>
                    <el-col :span="16">
                      <div class="list-txt">
                        <h5 v-text="item.title"></h5>
                        <p>
                          <span class="list-txt-left" v-text="item.pushDate||item.modifyDate"></span>
                          <span class="list-txt-mid" v-text="item.fromSource"></span>
                          <span class="list-txt-right">
                            <img src="../../assets/mobile/yidu@2x.png">
                            {{item.showNum}}已读
                          </span>
                        </p>
                      </div>
                    </el-col>
                  </el-row>
                </div>
              </div>
            </template>
            <template slot="empty">
              <div class="nodata">
                <img src="../../assets/mobile/zanwushuju.png">
              </div>
            </template>
            <template slot="paging">
              <div style="text-align:center">
                <p @click="handleNewsMore('news','llyj')">更多</p>
              </div>
            </template>
          </bs-page>
        </el-tab-pane>
        <el-tab-pane label="对外交流" name="third">
          <bs-page
            :is-init="false"
            :filter="{pageIndex:1, pageSize: 10}"
            :meta="{ module:'news', field:'dwjl' }"
            ref="refId"
          >
            <template slot="data" slot-scope="slot">
              <div class="list">
                <div
                  v-for="item in slot.data"
                  :key="item.newId"
                  @click="handleNewDetail('news','dwjl_detail',item)"
                >
                  <el-row>
                    <el-col :span="8">
                      <div class="grid-content">
                        <img :src="item.imgUrl||$app.mobilenodata.img">
                      </div>
                    </el-col>
                    <el-col :span="16">
                      <div class="list-txt">
                        <h5 v-text="item.title"></h5>
                        <p>
                          <span class="list-txt-left" v-text="item.pushDate||item.modifyDate"></span>
                          <span class="list-txt-mid" v-text="item.fromSource"></span>
                          <span class="list-txt-right">
                            <img src="../../assets/mobile/yidu@2x.png">
                            {{item.showNum}}已读
                          </span>
                        </p>
                      </div>
                    </el-col>
                  </el-row>
                </div>
              </div>
            </template>
            <template slot="empty">
              <div class="nodata">
                <img src="../../assets/mobile/zanwushuju.png">
              </div>
            </template>
            <template slot="paging">
              <div style="text-align:center">
                <p @click="handleNewsMore('news','dwjl')">更多</p>
              </div>
            </template>
          </bs-page>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
require("../../styles/mobile/mobile-new-main.scss");
export default {
  data() {
    return {
      DataReload: {
        "0": false,
        "1": true,
        "2": true,
        "3": true
      },
      defaultImg: "/src/assets/mobile/default.png",
      result: {
        data: []
      },
      routeType: "new",
      activeName: "first"
    };
  },
  components: {
    MobileNavbar: () => import("../mobile/mobile-navbar"),
    BsPage: () => import("../../components/bs-page"),
    BsList: () => import("../../components/bs-list")
  },
  methods: {
    handleClick(tab, event) {
      if (this.DataReload[tab.index]) {
        tab.$children[0].loadData();
        this.DataReload[tab.index] = false;
      }
    },
    handleNewsMore(moudle, field) {
      this.$router.push({ path: `/mobile/new/page/${moudle}/${field}` });
    },
    handleNewList(moudle, field) {
      this.$router.push({
        path: `/mobile/new/list/${moudle}/${field}`
      });
    },
    handleNewDetail(moudle, field, item) {
      this.$router.push({
        path: `/mobile/new/detail/${moudle}/${field}/${item.newId}`
      });
    },
    handleSingleArtiDetail(moudle, field) {
      this.$router.push({
        path: `/mobile/arti/single/detail/${moudle}/${field}`
      });
    },
    handleCultiDetail(moudle, field) {
      this.$router.push({
        path: `/mobile/cult/detail/${moudle}/${field}`
      });
    },
    handleSociety(_moudle, _field){
       this.$router.push({
        path: `/mobile/society-help/page/${_moudle}/${_field}`
      });
    }
  },
  created() {
    this.$menuFn.setTitle("致读者");
  },
  watch: {
    $route: function(to, from) {
      if (to.name === "mobile-new-main") {
        this.$menuFn.setTitle("致读者");
      }
    }
  }
};
</script>
